import Cookies from 'js-cookie';

const SESSION_ID = 'session_id';

const useSessionId = (): string => {
  /* TIP for work with SSO log in on localhost, set the value to the Session-Id in the stage environment.
  See Details:
   https://plusgrade.jira.com/wiki/spaces/FRON/pages/4316856503/How+to+maintain+the+points+SSO+login+status+on+localhost+after+log+in+with+SSO+on+stage
  */
  const sessionId = Cookies.get(SESSION_ID) ?? crypto.randomUUID();

  Cookies.set(SESSION_ID, sessionId);

  return sessionId;
};

export default useSessionId;
